document.addEventListener("DOMContentLoaded", function () {
    let appState = {
        states: {}
    };
    const saveState = function () {
        !(function (appState, saveState, restoredState) {
            const iconListData = new Date();
            iconListData.setTime(iconListData.getTime() + 365 * 24 * 60 * 60 * 1000);
            let btnHTML = "expires=" + iconListData.toUTCString();
            document.cookie = "asw=" + saveState + ";" + btnHTML + ";path=/";
        })(0, JSON.stringify(appState));
    };
    let restoredState = (function (appState) {
        let saveState = "asw=",
            restoredState = decodeURIComponent(document.cookie).split(";");
        for (let appState = 0; appState < restoredState.length; appState++) {
            let iconListData = restoredState[appState];
            for (;
                " " == iconListData.charAt(0);) iconListData = iconListData.substring(1);
            if (0 == iconListData.indexOf(saveState)) return iconListData.substring(saveState.length, iconListData.length);
        }
        return "";
    })();
    try {
        // Ohne gespeicherte Einstellung liefert die Suche oben "" zurück, und
        // JSON.parse("") wirft "Unexpected end of JSON input". Das passierte bei
        // jedem Seitenaufruf, solange der Besucher nichts eingestellt hat - also
        // bei praktisch allen Besuchern.
        restoredState = restoredState ? JSON.parse(restoredState) : {};
    } catch (e) {
        console.warn("State konnte nicht geladen werden", e);
        // Muss ein Objekt sein: der Spread weiter unten würde einen String sonst
        // in seine Einzelzeichen zerlegen.
        restoredState = {};
    }
    appState = {
        states: {},
        ...restoredState
    };
    let iconListData = ["format_size", "add", "remove", "restart_alt", "close"];
    const btnHTML = function (saveState, restoredState) {
        let btnHTML = "";
        for (let contentAdjustmentsHTML = 0; contentAdjustmentsHTML < saveState.length; contentAdjustmentsHTML++) {
            let colorAdjustmentsHTML = saveState[contentAdjustmentsHTML],
                toolAdjustmentsHTML = appState.states[colorAdjustmentsHTML.key];
            "wcag-filter" == restoredState && appState.states.contrast == colorAdjustmentsHTML.key && (toolAdjustmentsHTML = !0),
                (btnHTML += `\n<div class="wcag-btn ${restoredState || ""} ${toolAdjustmentsHTML ? "wcag-selected" : ""}" role="button" aria-pressed="false" data-key="${colorAdjustmentsHTML.key}" aria-label="${colorAdjustmentsHTML.label}" title="${colorAdjustmentsHTML.label}"><span class="material-icons wcag-icon">${colorAdjustmentsHTML.icon}</span>${colorAdjustmentsHTML.label
                    }\n</div>`),
                iconListData.push(colorAdjustmentsHTML.icon);
        }
        return btnHTML;
    };
    let contentAdjustmentsHTML = btnHTML([
        {
            label: "Links hervorheben",
            key: "highlight-links",
            icon: "link"
        },
        {
            label: "Titel hervorheben",
            key: "highlight-title",
            icon: "title"
        },
        {
            label: "Lesbare Schrift",
            key: "readable-font",
            icon: "local_parking"
        },
    ]),
        colorAdjustmentsHTML = btnHTML([
            {
                label: "Helle Kontraste",
                key: "light-contrast",
                icon: "brightness_5",
            },
            {
                label: "Dunkle Kontraste",
                key: "dark-contrast",
                icon: "nightlight"
            },
            {
                label: "Hoher Kontrast",
                key: "high-contrast",
                icon: "tonality"
            },
            {
                label: "Niedrige Sättigung",
                key: "low-saturation",
                icon: "gradient"
            },
            {
                label: "Hohe Sättigung",
                key: "high-saturation",
                icon: "filter_vintage",
            },
            {
                label: "Monochrom",
                key: "monochrome",
                icon: "filter_b_and_w"
            },
        ],
            "wcag-filter",
        ),
        toolAdjustmentsHTML = btnHTML([
            {
                label: "Großer Cursor",
                key: "big-cursor",
                icon: "mouse"
            },
            {
                label: "Lesehilfe",
                key: "readable-guide",
                icon: "local_library",
            },
            {
                label: "Bilder ausblenden",
                key: "hide-images",
                icon: "image"
            },
            {
                label: "Animationen anhalten",
                key: "stop-animations",
                icon: "motion_photos_off",
            },
        ],
            "wcag-tools",
        );
    var widgetContainer = document.getElementById("wcag-widget-container");
    widgetContainer.innerHTML += `<div class="wcag-widget"> <div class="wcag-menu"> <span class="wcag-menu-header h5">Barrierefreiheitsmenü<div> <div role="button" class="wcag-menu-reset" title="Reset Settings"> <span class="material-icons wcag-icon"> restart_alt </span> </div><div role="button" class="wcag-menu-close" title="Schließe Barrierefreiheitsmenü"> <span class="material-icons wcag-icon"> close </span> </div></div></span><div class="wcag-menu-content"> <div class="wcag-card" style="margin-top:15px;"> <span class="wcag-h5 h5"> Inhaltliche Anpassungen </span><div class="wcag-adjust-font"> <div class="label"> <span class="material-icons wcag-icon" style="margin-right:8px;"> format_size </span> Schriftgröße anpassen </div><div> <div class="wcag-minus" data-key="font-size" role="button" aria-pressed="false"> <span class="material-icons wcag-icon"> remove </span> </div><div class="wcag-amount"> ${appState.states.fontSize && 1 != appState.states.fontSize
        ? `${parseInt(100 * appState.states.fontSize)}%` : "Standard"
        }</div><div class="wcag-plus" data-key="font-size" role="button" aria-pressed="false"> <span class="material-icons wcag-icon"> add </span> </div></div></div><div class="wcag-items"> ${contentAdjustmentsHTML}</div></div><div class="wcag-card" style="margin-top:15px;"> <span class="wcag-h5 h5"> Farbanpassungen </span><div class="wcag-items"> ${colorAdjustmentsHTML}</div></div><div class="wcag-card" style="margin-top:15px;"> <span class="wcag-h5 h5"> Werkzeuge </span><div class="wcag-items"> ${toolAdjustmentsHTML}</div></div><div class="wcag-resize-handle" title="Größe ändern"></div></div></div></>`;
    const injectStyle = function (appState, saveState) {
        let restoredState =
            document.getElementById(saveState || "") || document.createElement("style");
        (restoredState.innerHTML = appState), restoredState.id || ((restoredState.id = saveState), document.head.appendChild(restoredState));
    },
        getVendorPrefixedStyle = function (appState, saveState) {
            let restoredState = "",
                iconListData = ["-colorAdjustmentsHTML-", "-ms-", "-moz-", "-webkit", ""];
            for (let btnHTML = 0; btnHTML < iconListData.length; btnHTML++) restoredState += iconListData[btnHTML] + (saveState || "filter") + ":" + appState + ";";
            return restoredState;
        },
        applyFilter = function (appState) {
            let saveState = "";
            if (appState) {
                let iconListData = "";
                "dark-contrast" == appState
                    ?
                    (iconListData =
                        "color:#fff !important;fill:#FFF !important;background-color:#000 !important;") : "light-contrast" == appState ?
                        (iconListData =
                            " color:#000 !important;fill:#000 !important;background-color:#FFF !important;") : "high-contrast" == appState ?
                            (iconListData += getVendorPrefixedStyle("contrast(125%)")) : "high-saturation" == appState ?
                                (iconListData += getVendorPrefixedStyle("saturate(200%)")) : "low-saturation" == appState ?
                                    (iconListData += getVendorPrefixedStyle("saturate(50%)")) : "monochrome" == appState && (iconListData += getVendorPrefixedStyle("grayscale(100%)"));
                let btnHTML = [""];
                ("dark-contrast" != appState && "light-contrast" != appState) ||
                    (btnHTML = [
                        "",
                        "h1:not(.header__logo)",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "p",
                        "span",
                        "i",
                        "svg",
                        "a:not(.logo-list__item)",
                        "button",
                        "label",
                        "li",
                        "ol",
                        "variant-sku",
                        "sale-price",
                        "compare-at-price",
                        "on-sale-badge",
                        "legend",
                    ]);
                for (let restoredState = 0; restoredState < btnHTML.length; restoredState++)
                    saveState += '[data-wcag-filter="' + appState + '"] ' + btnHTML[restoredState] + "{" + iconListData + "}";
            }
            injectStyle(saveState, "wcag-filter-style"),
                appState ?
                    document.documentElement.setAttribute("data-wcag-filter", appState) : document.documentElement.removeAttribute("data-wcag-filter", appState);
        },
        updateWidgetUI = function () {
            let saveState = [{
                id: "highlight-title",
                childrenSelector: ["h1", "h2", "h3", "h4", "h5", "h6"],
                css: "outline:2px solid #D30000 !important;outline-offset:2px !important;",
            },
            {
                id: "highlight-links",
                childrenSelector: ["a[href]"],
                css: "outline:2px solid #D30000 !important;outline-offset:2px !important;",
            },
            {
                id: "readable-font",
                childrenSelector: [
                    "",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "p",
                    "span:not(.wcag-icon)",
                    "i",
                    "svg",
                    "a",
                    "button",
                    "label",
                    "li",
                    "ol",
                    "variant-sku",
                    "sale-price",
                    "compare-at-price",
                    "legend",
                ],
                css: "font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;",
            },
            ],
                restoredState = "";
            for (let iconListData = 0; iconListData < saveState.length; iconListData++) {
                let contentAdjustmentsHTML = saveState[iconListData];
                if (
                    (document.documentElement.classList.toggle(contentAdjustmentsHTML.id, !!appState.states[contentAdjustmentsHTML.id]),
                        appState.states[contentAdjustmentsHTML.id])
                )
                    for (var btnHTML = contentAdjustmentsHTML.childrenSelector.length; btnHTML--;)
                        restoredState += "." + contentAdjustmentsHTML.id + " " + contentAdjustmentsHTML.childrenSelector[btnHTML] + "{" + contentAdjustmentsHTML.css + "}";
            }
            if (appState.states["hide-images"]) {
                document.querySelectorAll("img").forEach(el => {
                    const span = document.createElement("span");
                    let altText = "";
                    altText = el.alt?.trim() || "";

                    if (altText) {
                        span.textContent = altText;
                        span.style.color = "black";
                    } else {
                        span.textContent = "Kein Alt-Text";
                        span.style.color = "red";
                    }

                    span.style.fontSize = "16px";
                    span.setAttribute("data-original", el.outerHTML);
                    el.replaceWith(span);
                });
            } else {
                document.querySelectorAll("span[data-original]").forEach(span => {
                    const temp = document.createElement("div");
                    temp.innerHTML = span.getAttribute("data-original");
                    const originalElement = temp.firstChild;
                    span.replaceWith(originalElement);
                });
            }
            var contentAdjustmentsHTML = document.querySelector(".wcag-rg-container");
            if (appState.states["readable-guide"]) {
                if (!contentAdjustmentsHTML) {
                    var colorAdjustmentsHTML = document.createElement("div");
                    colorAdjustmentsHTML.setAttribute("class", "wcag-rg-container"),
                        (colorAdjustmentsHTML.innerHTML =
                            '<style>    .wcag-rg {position:fixed;top:0;left:0;right:0;width:100%;height:0;pointer-events:none;background-color:rgba(0,0,0,.5);z-index:1000000;    }</style><div class="wcag-rg wcag-rg-top"></div><div class="wcag-rg wcag-rg-bottom" style="top:auto;bottom:0;"></div>\n');
                    let appState = colorAdjustmentsHTML.querySelector(".wcag-rg-top"),
                        saveState = colorAdjustmentsHTML.querySelector(".wcag-rg-bottom"),
                        restoredState = 20;
                    (window.onScrollReadableGuide = function (iconListData) {
                        (appState.style.height = iconListData.clientY - restoredState + "px"),
                            (saveState.style.height = window.innerHeight - iconListData.clientY - restoredState - restoredState + "px");
                    }),
                        document.addEventListener(
                            "mousemove",
                            window.onScrollReadableGuide,
                            !1,
                        ),
                        document.body.appendChild(colorAdjustmentsHTML);
                }
            } else
                contentAdjustmentsHTML &&
                    (contentAdjustmentsHTML.remove(),
                        document.removeEventListener(
                            "mousemove",
                            window.onScrollReadableGuide,
                        ));
            appState.states["stop-animations"] &&
                (restoredState += `\nbody * {${getVendorPrefixedStyle("none !important", "transition")}${getVendorPrefixedStyle("forwards !important", "animation-fill-mode")}${getVendorPrefixedStyle("1 !important", " animation-iteration-count")}${getVendorPrefixedStyle(".01s !important", "animation-duration")}\n}`),
                appState.states["big-cursor"] &&
                (restoredState +=
                    "\nbody * {cursor:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 512 512'%3E%3Cpath d='M429.742 319.31L82.49 0l-.231 471.744 105.375-100.826 61.89 141.083 96.559-42.358-61.89-141.083 145.549-9.25zM306.563 454.222l-41.62 18.259-67.066-152.879-85.589 81.894.164-333.193 245.264 225.529-118.219 7.512 67.066 152.878z' fill='black' stroke='white' stroke-width='10'/%3E%3C/svg%3E\") ,default !important;\n}"),
                appState.states["readable-font"] &&
                (restoredState += '\nbody { font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; }');
            injectStyle(restoredState, "wcag-content-style");
        };
    var handleToggleButton = function (restoredState) {
        restoredState.preventDefault();
        let iconListData = restoredState.currentTarget,
            btnHTML = iconListData.dataset.key;
        iconListData.classList.contains("wcag-filter") ?
            (document.querySelectorAll(".wcag-filter").forEach(function (appState) {
                appState.classList.remove("wcag-selected"),
                    appState.setAttribute("aria-pressed", "false");
            }),
                (appState.states.contrast = appState.states.contrast !== btnHTML && btnHTML),
                appState.states.contrast &&
                (iconListData.classList.add("wcag-selected"),
                    iconListData.setAttribute("aria-pressed", "true")),
                applyFilter(appState.states.contrast)) : ((appState.states[btnHTML] = !appState.states[btnHTML]),
                    iconListData.classList.toggle("wcag-selected", appState.states[btnHTML]),
                    iconListData.setAttribute("aria-pressed", appState.states[btnHTML] ? "true" : "false"),
                    updateWidgetUI()),
            saveState();
    };
    const updateFontSize = function (saveState, restoredState) {
        let iconListData = !1;
        !restoredState &&
            saveState &&
            ((iconListData = saveState.currentTarget),
                (restoredState = parseFloat(appState.states.fontSize) || 1),
                iconListData.classList.contains("wcag-minus") ? (restoredState -= 0.1) : (restoredState += 0.1),
                (restoredState = Math.max(restoredState, 0.1)),
                (restoredState = Math.min(restoredState, 2)),
                (restoredState = parseFloat(restoredState.toFixed(2)))),
            document
                .querySelectorAll("h1,h2,h3,h4,h5,h6,p,a,dl,dt,li,ol,th,td,span:not(.wcag-menu-header, .wcag-h5),variant-sku,sale-price,compare-at-price,legend")
                .forEach(function (appState) {
                    if (!appState.classList.contains("material-icons")) {
                        let saveState = appState.getAttribute("data-wcag-orgFontSize");
                        saveState ||
                            ((saveState = parseInt(
                                window.getComputedStyle(appState, null).getPropertyValue("font-size"),
                            )),
                                appState.setAttribute("data-wcag-orgFontSize", saveState));
                        let iconListData = saveState * restoredState;
                        let b = iconListData + 4;
                        appState.style.setProperty("font-size", iconListData + "px", "important");
                        appState.style.setProperty("line-height", b + "px", "important");
                    }

                });
        let btnHTML = "Standard";
        1 !== restoredState &&
            (restoredState > 1 ? (btnHTML = "+") : restoredState < 1 && (btnHTML = "-"), (btnHTML += parseInt(100 * restoredState) + "%")),
            iconListData && (iconListData.parentElement.querySelector(".wcag-amount").innerHTML = btnHTML),
            (appState.states.fontSize = restoredState);
    };
    let menuElement = widgetContainer.querySelector(".wcag-menu");
    document.querySelectorAll(".icon-wcag").forEach(function (el) {
        el.addEventListener("click", function () {
            menuElement.style.display = menuElement.style.display === "block" ? "none" : "block";
        });
    }),
        menuElement.querySelector(".wcag-menu-close").addEventListener(
            "click",
            function () {
                (menuElement.style.display = "none");
            },
            !1,
        ),
        menuElement.querySelector(".wcag-menu-reset").addEventListener(
            "click",
            function () {
                (appState.states = {}),
                    applyFilter(),
                    updateWidgetUI(),
                    updateFontSize(void 0, 1),
                    document.querySelectorAll(".wcag-btn").forEach(function (appState) {
                        appState.classList.remove("wcag-selected"),
                            appState.setAttribute("aria-pressed", "false");
                    }),
                    document.querySelectorAll(".wcag-amount").forEach(function (appState) {
                        appState.innerHTML = "Standard";
                    }),
                    menuElement.removeAttribute('style'),

                    menuElement.style.top = '20px',
                    menuElement.style.left = (window.innerWidth - 520) + 'px',
                    menuElement.style.margin = '0px',
                    menuElement.style.transition = 'none',
                    menuElement.style.display = 'block',
                    localStorage.removeItem('wcagWidgetState');
                    saveState();
            },
            !1,
        ),
        menuElement.querySelectorAll(".wcag-btn").forEach(function (appState) {
            appState.addEventListener("click", handleToggleButton, !1);
        }),
        menuElement
            .querySelectorAll(".wcag-adjust-font div[role='button']")
            .forEach(function (appState) {
                appState.addEventListener(
                    "click",
                    (appState) => {
                        updateFontSize(appState), saveState();
                    },
                    !1,
                );
            }),
        restoredState &&
        (updateWidgetUI(),
            1 !== appState.states.fontSize && updateFontSize(null, appState.states.fontSize),
            appState.states.contrast && applyFilter(appState.states.contrast));
});

const observer = new MutationObserver(() => {
    const widget = document.querySelector('.wcag-menu');
    if (widget) {
        const header = widget.querySelector('.wcag-menu-header');
        if (!header) return;

        const STORAGE_KEY = 'wcagWidgetState';

        const saveWidgetState = () => {
            const state = {
                left: widget.style.left,
                top: widget.style.top,
                width: widget.style.width,
                height: widget.style.height
            };
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
            } catch (e) {
                // Ist der localStorage voll (QuotaExceededError) oder gesperrt
                // (Privatmodus), darf das nicht als unbehandelter Fehler aus dem
                // mouseup-Handler fliegen. Die Widget-Position geht dann verloren,
                // alles andere funktioniert weiter.
                console.warn('Widget-Position konnte nicht gespeichert werden.', e);
            }
        };

        const loadWidgetState = () => {
            try {
                return JSON.parse(localStorage.getItem(STORAGE_KEY));
            } catch (e) {
                return null;
            }
        };

        // --- Initiale Position und Größe ---
        let isDragging = false;
        let startX, startY;

        const saved = loadWidgetState();

        if (saved && saved.left && saved.top) {
            widget.style.left = saved.left;
            widget.style.top = saved.top;
        } else {
            const initialTop = 20;
            const initialRightOffset = 20;
            const widgetWidth = 500;
            const currentX = window.innerWidth - widgetWidth - initialRightOffset;
            const currentY = initialTop;
            widget.style.left = `${currentX}px`;
            widget.style.top = `${currentY}px`;
        }

        if (saved && saved.width && saved.height) {
            widget.style.width = saved.width;
            widget.style.height = saved.height;
        }

        widget.style.position = 'fixed';
        widget.style.margin = '0';
        widget.style.transition = 'none';
        header.style.cursor = 'move';

        let currentX = parseInt(widget.style.left, 10);
        let currentY = parseInt(widget.style.top, 10);

        const onMouseMove = (e) => {
            if (!isDragging) return;

            const deltaX = e.clientX - startX;
            const deltaY = e.clientY - startY;

            let newX = currentX + deltaX;
            let newY = currentY + deltaY;

            const headerRect = header.getBoundingClientRect();

            const minX = 0;
            const maxX = window.innerWidth - headerRect.width;
            const minY = 0;
            const maxY = window.innerHeight - headerRect.height;

            newX = Math.min(Math.max(newX, minX), maxX);
            newY = Math.min(Math.max(newY, minY), maxY);

            widget.style.left = `${newX}px`;
            widget.style.top = `${newY}px`;
        };

        header.addEventListener('mousedown', (e) => {
            e.preventDefault();
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            currentX = parseInt(widget.style.left, 10);
            currentY = parseInt(widget.style.top, 10);
            document.body.style.userSelect = 'none';
        });

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', () => {
            if (isDragging) {
                saveWidgetState();
            }
            isDragging = false;
            document.body.style.userSelect = 'auto';
        });

        // Resize
        const resizeHandle = widget.querySelector('.wcag-resize-handle');
        if (resizeHandle) {
            let isResizing = false;
            let startWidth, startHeight, startX, startY;

            resizeHandle.addEventListener('mousedown', (e) => {
                e.preventDefault();
                isResizing = true;
                startX = e.clientX;
                startY = e.clientY;
                startWidth = parseInt(window.getComputedStyle(widget).width, 10);
                startHeight = parseInt(window.getComputedStyle(widget).height, 10);
                document.body.style.userSelect = 'none';
            });

            const onMouseMoveResize = (e) => {
                if (!isResizing) return;
                const newWidth = Math.max(350, startWidth + e.clientX - startX);
                const newHeight = Math.max(350, startHeight + e.clientY - startY);
                widget.style.width = newWidth + 'px';
                widget.style.height = newHeight + 'px';
            };

            const stopResizing = () => {
                if (isResizing) {
                    saveWidgetState();
                }
                isResizing = false;
                document.body.style.userSelect = 'auto';
            };

            document.addEventListener('mousemove', onMouseMoveResize);
            document.addEventListener('mouseup', stopResizing);
        }

        observer.disconnect();
    }
});

observer.observe(document.body, { childList: true, subtree: true });